import styled, { css, keyframes } from 'styled-components';
import { generateClassNames, applyDisplayNames, scrollBar } from '../../utils/functions';
import { Color as PColor } from '../../utils/types/palette';
import { BorderRadiusSize as BRSize } from '../../utils/types/shape';
var baseClassName = 'Menu';
var Overlay = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'Overlay')
}).withConfig({
  componentId: "sc-10okxhw-0"
})(function () {
  return css(["position:fixed;right:0;bottom:0;top:0;left:0;background-color:transparent;z-index:-1;"]);
});
var opacityKeyframes = /*#__PURE__*/keyframes(["from{opacity:0;}to{opacity:1;}"]);
var transformKeyframes = /*#__PURE__*/keyframes(["from{transform:scale(0.97);margin-top:0px;}to{transform:scale(1);margin-top:4px;}"]);
var fadeInAnimation = /*#__PURE__*/css(["animation:", " 250ms 0ms cubic-bezier(0.4,0,0.2,1),", " 250ms cubic-bezier(0.4,0,0.2,1);"], opacityKeyframes, transformKeyframes);
var Menu = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-10okxhw-1"
})(function (_ref) {
  var rect = _ref.rect,
    theme = _ref.theme,
    scroll = _ref.scroll,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '' : _ref$maxHeight;
  return css(["min-width:", "px;width:195px;min-height:16px;overflow-x:hidden;overflow-y:auto;transition:opacity 250ms cubic-bezier(0.4,0,0,1),transform 250ms cubic-bezier(0.4,0,0,1),margin-top 250ms cubic-bezier(0.4,0,0,1);outline:0;box-shadow:0 2px 4px ", ";border-radius:", ";", " ", " margin-top:4px;", ""], rect.width, theme.palette[PColor.MediumShadow], theme.shape.borderRadius[BRSize.Md], scroll && scrollBar, maxHeight && css(["max-height:", ";"], Number.isNaN(+maxHeight) ? maxHeight : "".concat(maxHeight, "px")), fadeInAnimation);
});
var Styled = applyDisplayNames({
  Menu: Menu,
  Overlay: Overlay
});
export default Styled;